import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_RO.json';
import recipes from './COOKING_RECIPES_RO.json';
import videos from './COOKING_VIDEOS_RO.json';

export const COOKING_DATA_RO: ServiceData = {
  articles,
  recipes,
  videos,
};
